'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

/**
 * This client-side component ensures the <body> element gets the correct CSS class
 * based on the current route after client-side navigation.
 *
 * WHY THIS IS NEEDED:
 * - In Next.js App Router, the <body> tag in layout.tsx does not re-render during navigation.
 * - Therefore, any class set at the server level (via middleware/header) will not update when navigating client-side.
 */
export function BodyClassUpdater() {
  const pathname = usePathname()

  useEffect(() => {
    const isRoot = pathname === '/'
    document.body.classList.toggle('is-root-page', isRoot)
  }, [pathname])

  return null
}
